import { useDashboardContext } from "../pages/DashboardLayout";
import links from "../utils/links";
import { NavLink } from "react-router-dom";

const NavLinks = () => {
  const { user, toggleSidebar } = useDashboardContext();
  const { role } = user; // תפקיד המשתמש

  return (
    <div className="nav-links">
      {links
        .filter(
          (link, index, self) => index === self.findIndex((l) => l.path === link.path)) 
        .filter((link) => {
          //filter links based on user role
          const isAllowed = link.role.includes(role) || role === "admin";
          return isAllowed;
        })
        .map((link) => {
          const { text, path, icon } = link;
          return (
            <NavLink
              to={path}
              key={path}
              onClick={toggleSidebar}
              className="nav-link"
              end
            >
              <span className="icon">{icon}</span>
              {text}
            </NavLink>
          );
        })}
    </div>
  );
};

export default NavLinks;
